import React from 'react';
import appParameters from '../../../utils/AppParameters';
import shapeTypes from '../../../../constants/ShapeConstants';
import { ShapeTypeElement } from './subcomponents/ShapeTypeElement';

export const TextBoxArea = React.createClass({
    render() {
        let elementWidth = this.props.elementWidth;
        let menuStyle = {
            position: 'absolute',
            width: this.props.width,
            top: 0
        };

        let buttonsHolderStyle = {
            position: 'absolute',
            top: this.props.topGap
        };

        let lineStyle = {
            position: 'absolute',
            width: this.props.width,
            height: 1,
            top: elementWidth + 2 * this.props.topGap,
            left: 0,
            backgroundColor: '#c4c4c4'
        };

        return (
            <div style={menuStyle}>
                <div style={buttonsHolderStyle}>
                    <ShapeTypeElement id='textBoxSimpleButton' index={0} executeCommand={this.props.executeCommand} dispatch={this.props.dispatch} contextTarget={this.props.contextTarget} type={shapeTypes.TEXTBOXSIMPLE} width={elementWidth} src={appParameters.RESOURCES_LOCATION() + 'assets/simpleText.png'}/>
                    <ShapeTypeElement index={1} executeCommand={this.props.executeCommand} dispatch={this.props.dispatch} contextTarget={this.props.contextTarget} type={shapeTypes.TEXTBOX} width={elementWidth} src={appParameters.RESOURCES_LOCATION() + 'assets/textBoxIcon.png'}/>
                    <ShapeTypeElement index={2} executeCommand={this.props.executeCommand} dispatch={this.props.dispatch} contextTarget={this.props.contextTarget} type={shapeTypes.SPEAK_BUBBLE} width={elementWidth} src={appParameters.RESOURCES_LOCATION() + 'assets/speachBubble.png'}/>
                    <ShapeTypeElement index={3} executeCommand={this.props.executeCommand} dispatch={this.props.dispatch} contextTarget={this.props.contextTarget} type={shapeTypes.THOUGHT_BUBBLE} width={elementWidth} src={appParameters.RESOURCES_LOCATION() + 'assets/thoughtBubble.png'}/>
                    <ShapeTypeElement index={4} executeCommand={this.props.executeCommand} dispatch={this.props.dispatch} contextTarget={this.props.contextTarget} type={shapeTypes.SCREAM_BUBBLE} width={elementWidth} src={appParameters.RESOURCES_LOCATION() + 'assets/screamBubble.png'}/>
                    <ShapeTypeElement index={5} executeCommand={this.props.executeCommand} dispatch={this.props.dispatch} contextTarget={this.props.contextTarget} type={shapeTypes.COMPLEX_SPEAK_BUBBLE} width={elementWidth} src={appParameters.RESOURCES_LOCATION() + 'assets/complexSpeachBubble.png'}/>
                </div>

                <div style={lineStyle}></div>
            </div>
        );
    }
});


/** WEBPACK FOOTER **
 ** ./src/components/menus/textEditorTool/components/TextBoxArea.js
 **/